import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { ChakraProvider, theme } from '@chakra-ui/react';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import MovieInfo from './components/MovieInfo';
import NewMovies from './components/NewMovies';

const client = new ApolloClient({
  uri: '/graphql',
  cache: new InMemoryCache(),
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ColorModeSwitcher justifySelf="flex-end" />
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<NewMovies />} />
            <Route exact path="/info/:id" element={<MovieInfo />} />
          </Routes>
        </BrowserRouter>
      </ApolloProvider>
    </ChakraProvider>
  );
}

export default App;
